if (import.meta.browser) {
    addEventListener("error", function suppressHydrationWarning (event) {
        if (event.message.startsWith("Uncaught Error: Minified React error #418")) {
            event.preventDefault()
        }
    })
}
